<template>
  <div>
    <v-card-text class="pt-0 mt-0">
      <v-row class="mb-4">
        <v-col cols="12">
          <div class="text-h5 primary--text mb-2">
            <v-icon large color="primary" class="mr-2"
              >mdi-shield-account</v-icon
            >
            {{ resolveTitle }}
          </div>
          <v-divider></v-divider>
        </v-col>
      </v-row>

      <v-row dense class="mt-4" v-if="obrasSociales.length > 0">
        <v-col cols="12" md="4" sm="12">
          <v-select
            :items="obrasSociales"
            item-text="nombre"
            item-value="idObraSocial"
            prepend-icon="mdi-card-account-details"
            v-model="obraSocial"
            :label="resolveLabel"
            dense
            outlined
            color="primary"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="12" md="4" v-if="requiereNroAfiliado">
          <v-text-field
            v-model="nroAfiliado"
            prepend-icon="mdi-account"
            label="Nro. Afiliado *"
            maxlength="100"
            :rules="requiredRules"
            dense
            outlined
            color="primary"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="12" md="4" v-if="idInstitucion === 784">
          <v-text-field
            v-model="nroSocio"
            prepend-icon="mdi-card-account-details"
            label="Número de socio *"
            maxlength="100"
            :rules="requiredRules"
            dense
            outlined
            color="primary"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4" md="4" v-if="tiposTurno.length">
          <v-select
            :items="tiposTurno"
            v-model="tipoDeTurno"
            item-text="nombreTipoTurno"
            item-value="idTipoTurno"
            label="Tipo de Turno *"
            dense
            outlined
            color="primary"
            prepend-icon="mdi-calendar-clock"
            return-object
            no-data-text="No hay Tipos de Turno configurados"
          ></v-select>
        </v-col>
      </v-row>

      <v-row dense class="mt-4" v-if="obrasSociales.length == 0">
        <v-col cols="12">
          <v-alert color="error" dark prominent icon="mdi-alert-circle">
            <v-row align="center">
              <v-col class="grow">
                No hay Obras Sociales configuradas para el portal, comuníquese
                directamente con la institución
              </v-col>
            </v-row>
          </v-alert>
        </v-col>
      </v-row>

      <v-row v-if="idInstitucion === 784" class="mt-0 mb-2">
        <v-col cols="12">
          <v-alert color="info" dark outlined prominent icon="mdi-information">
            Turnos disponibles únicamente para socios del club
          </v-alert>
        </v-col>
      </v-row>

      <v-row v-if="observaciones && muestraObservaciones">
        <v-col cols="12">
          <v-alert color="info" dark outlined prominent icon="mdi-information">
            {{ observaciones }}
          </v-alert>
        </v-col>
      </v-row>

      <v-row dense class="mt-4">
        <v-col cols="12" sm="4" md="3">
          <v-btn
            :disabled="
              obrasSociales.length === 0 ||
              (requiereNroAfiliado && !nroAfiliado) ||
              (idInstitucion === 784 && !nroSocio)
            "
            large
            color="success"
            @click.stop="seleccionar"
            block
            elevation="2"
          >
            <v-icon left>mdi-arrow-right</v-icon>
            Continuar
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </div>
</template>

<style scoped>
.v-btn {
  transition: all 0.3s;
}

.v-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2) !important;
}
</style>
<script>
import { requiereNroAfiliado } from "../config/instituciones.js";

export default {
  props: ["obrasSociales", "idInstitucion", "tiposTurno"],
  watch: {
    obrasSociales: function (val) {
      if (val.length > 0) {
        this.obraSocial = val[0].idObraSocial;
        this.observaciones = val[0].observaciones;
        this.muestraObservaciones = val[0].muestraObservacionesEnWeb;
      }
    },
    tiposTurno: {
      handler(val) {
        if (val.length > 0) {
          this.tipoDeTurno = val.find((tt) => tt.porDefecto) ?? val[0];
        }
      },
    },
    obraSocial: {
      handler(val) {
        if (val) {
          this.observaciones = this.obrasSociales.find(
            (os) => os.idObraSocial === val,
          ).observaciones;
          this.muestraObservaciones = this.obrasSociales.find(
            (os) => os.idObraSocial === val,
          ).muestraObservacionesEnWeb;
        }
      },
    },
  },
  data: (vm) => ({
    obraSocial: null,
    nroAfiliado: "",
    nroSocio: "",
    tipoDeTurno: null,
    observaciones: "",
    muestraObservaciones: false,
    requiredRules: [(v) => !!v || "Campo obligatorio"],
  }),
  computed: {
    requiereNroAfiliado() {
      return requiereNroAfiliado(this.idInstitucion);
    },
    resolveLabel() {
      if ([454].includes(this.idInstitucion)) {
        return "Modalidad de Atención *";
      }
      return this.$store.state.esEmpresa
        ? "Sede *"
        : "Obras Sociales Vigentes *";
    },
    resolveTitle() {
      let title = "";
      if ([454].includes(this.idInstitucion)) {
        title = "Modalidad de Atención";
      }
      title = this.$store.state.esEmpresa ? "Sede" : "Obra Social";

      if (this.tiposTurno.length) {
        title += " y Tipo de Turno";
      }

      return title;
    },
  },
  methods: {
    seleccionar() {
      this.$emit("obraSocialSeleccionada", {
        obraSocial: this.obraSocial,
        nroAfiliado: this.nroAfiliado,
        tipoDeTurno: this.tipoDeTurno,
      });
    },
  },
  mounted() {
    if (this.obrasSociales.length > 0) {
      this.obraSocial = this.obrasSociales[0].idObraSocial;
    }

    if (this.tiposTurno.length > 0) {
      this.tipoDeTurno = this.tiposTurno.find((tt) => tt.porDefecto);
    }
  },
};
</script>
